export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '派单日期',
		align: 'center',
		dataIndex: 'orderCreateTime',
		scopedSlots: { customRender: 'orderCreateTime' },
	},
	{
		title: '任务类型',
		align: 'center',
		dataIndex: 'taskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '所属地区',
		align: 'center',
		dataIndex: 'location',
	},
	{
		title: '医院名称',
		align: 'center',
		dataIndex: 'hospital',
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '结算状态',
		align: 'center',
		dataIndex: 'settleStatusDesc',
		// scopedSlots: { customRender: 'operationStatus' },
	},
	{
		title: '业务线',
		align: 'center',
		dataIndex: 'businessLineDesc',
		auth: 'dataPermission:businessLine', // 数据权限控制标识
	},
	{
		title: '发票号',
		align: 'center',
		dataIndex: 'invoices',
		auth: 'dataPermission:invoices', // 数据权限控制标识
		// scopedSlots: { customRender: 'operationStatus' },
	},
	{
		title: '作业状态',
		align: 'center',
		dataIndex: 'operationStatus',
		scopedSlots: { customRender: 'operationStatus' },
	},
	{
		title: '资源公司',
		align: 'center',
		dataIndex: 'partnerName',
	},
	{
		title: '作业人员',
		align: 'center',
		dataIndex: 'visitorName',
	},
	{
		title: '任务截止时间',
		align: 'center',
		dataIndex: 'endEffectTime',
		scopedSlots: { customRender: 'endEffectTime' },
	},
	{
		title: '响应时长',
		align: 'center',
		dataIndex: 'responeTimes',
	},
	{
		title: '超时',
		align: 'center',
		dataIndex: 'timeout',
		scopedSlots: { customRender: 'timeout' },
	},
	{
		title: '调度轮次',
		align: 'center',
		dataIndex: 'dispatchNumber',
		scopedSlots: { customRender: 'dispatchNumber' },
	},
	{
		title: '退回',
		align: 'center',
		dataIndex: 'auditFailedFlag',
		scopedSlots: { customRender: 'auditFailedFlag' },
	},
	{
		title: '延时',
		align: 'center',
		dataIndex: 'postoneFlag',
		scopedSlots: { customRender: 'postoneFlag' },
	},
	{
		title: '撤单',
		align: 'center',
		dataIndex: 'cancel',
		scopedSlots: { customRender: 'cancel' },
	},
	{
		title: '发起方',
		align: 'center',
		dataIndex: 'cancelType',
		scopedSlots: { customRender: 'cancelType' },
	},
	{
		title: '操作',
		align: 'center',
		dataIndex: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
